import {
  ArrowLeftOutlined,
  LoadingOutlined,
  LockOutlined,
  MailOutlined,
} from "@ant-design/icons";
import { notification } from "antd";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  authConfirmToken,
  authSendverifyEmail,
  sampleApiCall,
} from "../../../apiservice/authService";
import { IAuthType } from "../../../apiservice/authService.type";
import useFormatApiRequest from "../../../hooks/formatApiRequest";
import useAuth from "../../../hooks/useAuth";
import { useAppDispatch, useAppSelector } from "../../../Redux/reduxCustomHook";
import { RootState } from "../../../Redux/store";
import { NotificationType } from "../../../utils/mscType.type";
import "../userAuth.css";
import UserAuthHeader from "../userAuthHeader";

const UserVerifyEmail = () => {
  const [loadTokenApi, setLoadTokenApi] = useState(true);
  const [formLoading, setFormLoading] = useState<boolean>(true);
  const [loadApi, setLoadApi] = useState(false);
  const [payload, setPayload] = useState<any>({});

  const navigate = useNavigate();
  const authData: any = useAppSelector((state: RootState) => state);
  const [loadAuth, setLoadAuth] = useState(false);
  const [api, contextHolder] = notification.useNotification();

  // Use to collect Site Description Change
  const handleInputChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setPayload((values) => ({ ...values, [name]: value }));
  };

  // Use to Submit Form
  const handleSubmit = (event: any) => {
    event.preventDefault();
    setLoadApi(true);
    setFormLoading(true);
  };

  // Use to refresh the Auth State
  const authState = useAuth(loadAuth, () => {
    setLoadAuth(false);
  });

  // A custom hook to Send Token
  const resultSendToken = useFormatApiRequest(
    () => authSendverifyEmail(),
    loadTokenApi,
    () => {
      setLoadTokenApi(false);
    },
    () => {
      processTokenApiResult();
    }
  );

  // Process Api Token Result
  const processTokenApiResult = async () => {
    if (resultSendToken.httpState === "SUCCESS") {
      setFormLoading(false);
      // Handle Success Here
      openNotificationWithIcon(
        "info",
        "",
        "A code has being sent to your email",
        "#D9FFB5"
      );
    } else if (resultSendToken.httpState === "ERROR") {
      setFormLoading(false);
      //Handle Error Here
      openNotificationWithIcon(
        "info",
        "",
        result.data?.errors?.[0] ||
          result.data?.message ||
          result.errorMsg ||
          "Error in sending code",
        "#FFC2B7"
      );
    }
  };

  // A custom hook to format confirm OTP
  const result = useFormatApiRequest(
    () => authConfirmToken(payload),
    loadApi,
    () => {
      setLoadApi(false);
    },
    () => {
      processApi();
    }
  );

  // Process Api
  const processApi = async () => {
    if (result.httpState === "SUCCESS") {
      setFormLoading(false);
      setLoadAuth(true);
      // Handle Success Here
      openNotificationWithIcon(
        "info",
        "",
        "Your Email has being verified",
        "#D9FFB5"
      );
      setTimeout(() => {
        navigate("/users/preference-category");
      }, 2500);
    } else if (result.httpState === "ERROR") {
      setFormLoading(false);
      //Handle Error Here
      openNotificationWithIcon(
        "info",
        "",
        result.data?.response?.data?.errors?.[0].message ||
          result.data?.response?.data?.message ||
          result.errorMsg ||
          "Wrong Token",
        "#FFC2B7"
      );
    }
  };

  // Show Notification
  const openNotificationWithIcon = (
    type: NotificationType,
    message: string,
    description: string,
    background?: string
  ) => {
    api[type]({
      message,
      description,
      placement: "bottomRight",
      style: { background },
    });
  };

  return (
    <>
      {contextHolder}

      <div className="w-full min-h-screen flex justify-center bg-white dark:bg-stone-900">
        <div className="p-8 w-full max-w-lg rounded-lg bg-white dark:bg-stone-800 shadow-lg self-center">
          {" "}
          {/* Added self-center and card styles */}
          <div className="mb-2 flex items-center flex-col">
            <div className="flex items-center w-full">
              {/* Left-aligned Back Arrow */}
              <div className="flex items-center">
                <Link to="/auth">
                  <ArrowLeftOutlined className="text-lg text-blue-800 dark:text-blue-400" />
                </Link>
              </div>

              {/* Center-aligned Step Text */}
              <div className="flex w-full justify-center">
                <p className="text-black dark:text-stone-100 text-2xl font-semibold">
                  <u>Verify Your Email</u>
                </p>
              </div>
            </div>
          </div>
          {/* Logo Section */}
          <div className="w-full  flex flex-col items-center">
            <div className="p-4">
              <img
                src={`${process.env.PUBLIC_URL + "/images/logobluebig.svg"}`}
                alt="Logo"
                className="w-32 h-auto"
              />
              <br />

              {/* <img
              src={`${process.env.PUBLIC_URL + "/images/logoblue.svg"}`}
              alt="Logo"
              className="w-32 h-auto"
            /> */}
            </div>
          </div>
          <form onSubmit={handleSubmit}>
            {/* Token */}
            <div className="relative w-full mb-8">
              <label className="absolute -top-3 left-3 text-slate-900 dark:text-stone-200 px-1 bg-white dark:bg-stone-800 text-sm">
                Token
              </label>
              <input
                required
                name="token"
                value={payload?.token}
                onChange={handleInputChange}
                type="password" // Should this be type="text" for a token? Keeping as password for now.
                className="pl-10 pr-4 py-2 border dark:border-stone-600 rounded-lg w-full h-16 bg-transparent text-blue-800 dark:text-sky-300 placeholder-gray-500 dark:placeholder-stone-400"
                placeholder="Enter your code"
              />
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <LockOutlined className="text-slate-900 dark:text-stone-300" />
              </div>
            </div>

            {/* Resend Token  */}
            <div className="flex items-end justify-end mb-6">
              <span
                onClick={() => {
                  setLoadTokenApi(true);
                  setFormLoading(true);
                }}
                className="text-stone-700 dark:text-stone-300 fontAlbertSansRegular cursor-pointer hover:underline"
              >
                {!formLoading ? (
                  "Resend Code"
                ) : (
                  <LoadingOutlined rev={undefined} />
                )}
              </span>
            </div>

            {/* Sign Up Button */}
            <div className="mb-8">
              <button className="w-full h-16 fontAlbertSansRegular bg-blue-800 hover:bg-blue-700 dark:hover:bg-blue-600 text-white rounded-lg text-lg">
                {!formLoading ? (
                  "Verify Email"
                ) : (
                  <LoadingOutlined rev={undefined} />
                )}
              </button>
            </div>

            {/* Go To Login */}
            <div className="mb-8 text-center">
              {/* <p className="text-slate-900 dark:text-stone-300">
                Already have an account?{" "}
                <Link
                  to="/auth/signin"
                  className="underline text-slate-900 dark:text-stone-300 hover:dark:text-stone-100"
                >
                  Login
                </Link>
              </p> */}

              <p className="text-slate-900 dark:text-stone-300 mt-4">
                Can't Verify your Email Go Back{" "}
                <Link
                  to="/users/logout"
                  className="underline text-slate-900 dark:text-stone-300 hover:dark:text-stone-100"
                >
                  Logout
                </Link>
              </p>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default UserVerifyEmail;
